/**
 * Login Form Validation Schema
 * Zod schema for validating login form data
 */

import { z } from 'zod';

/**
 * Login form validation schema
 * Note: rememberMe uses boolean() without optional/default for cleaner type inference
 */
export const loginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  password: z
    .string()
    .min(1, 'Password is required')
    .min(8, 'Password must be at least 8 characters'),
  rememberMe: z.boolean(),
});

/**
 * TypeScript type inferred from schema
 */
export type LoginFormData = z.infer<typeof loginSchema>;

/**
 * Default values for the login form
 */
export const loginFormDefaults: LoginFormData = {
  email: '',
  password: '',
  rememberMe: false,
};
